<template>
    <footer class="bg-gradient-dark text-light py-5 mt-5">
        <div class="container">
            <div class="row">
                <!-- 购物车总结 -->
                <div class="col-lg-4 mb-4">
                    <h5 class="text-gradient-primary mb-3">
                        <i class="bi bi-cart-check-fill"></i> 购物车总结
                    </h5>
                    <div class="bg-glass p-4 rounded-3 shadow-lg">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span><i class="bi bi-basket-fill text-warning"></i> 已选商品</span>
                            <span class="badge bg-warning text-dark fs-6">{{ totalSelectedItems }} 件</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span><i class="bi bi-currency-yen text-success"></i> 总金额</span>
                            <span class="text-success fw-bold fs-5">¥{{ totalAmount.toFixed(2) }}</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <span><i class="bi bi-grid-3x3-gap-fill text-info"></i> 商品种类</span>
                            <span class="badge bg-info">{{ totalCategories }} 类</span>
                        </div>
                        <hr class="my-3">
                        <div class="text-center">
                            <button class="btn btn-outline-light btn-sm" @click="clearCart">
                                <i class="bi bi-trash"></i> 清空购物车
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 快速导航 -->
                <div class="col-lg-4 mb-4">
                    <h5 class="text-gradient-primary mb-3">
                        <i class="bi bi-compass-fill"></i> 快速导航
                    </h5>
                    <div class="nav-links">
                        <a href="#fruits" class="nav-link-custom" @click.prevent="scrollToCategory('fruits')">
                            <div class="icon-wrapper bg-danger">
                                <i class="bi bi-apple"></i>
                            </div>
                            <span>新鲜水果</span>
                            <small class="text-muted">({{ getCategoryCount('fruits') }}种)</small>
                        </a>
                        <a href="#clothing" class="nav-link-custom" @click.prevent="scrollToCategory('clothing')">
                            <div class="icon-wrapper bg-primary">
                                <i class="bi bi-bag-check"></i>
                            </div>
                            <span>时尚穿搭</span>
                            <small class="text-muted">({{ getCategoryCount('clothing') }}种)</small>
                        </a>
                        <a href="#wine" class="nav-link-custom" @click.prevent="scrollToCategory('wine')">
                            <div class="icon-wrapper bg-warning">
                                <i class="bi bi-cup-hot"></i>
                            </div>
                            <span>精选美酒</span>
                            <small class="text-muted">({{ getCategoryCount('wine') }}种)</small>
                        </a>
                    </div>
                </div>

                <!-- 联系信息 -->
                <div class="col-lg-4 mb-4">
                    <h5 class="text-gradient-primary mb-3">
                        <i class="bi bi-chat-dots-fill"></i> 联系我们
                    </h5>
                    <div class="contact-info">
                        <div class="contact-item">
                            <i class="bi bi-geo-alt-fill text-danger"></i>
                            <div>
                                <strong>地址</strong>
                                <p class="mb-0 text-light">北京市朝阳区华仔购物大厦</p>
                            </div>
                        </div>
                        <div class="contact-item">
                            <i class="bi bi-telephone-fill text-success"></i>
                            <div>
                                <strong>客服热线</strong>
                                <p class="mb-0 text-light">400-123-4567</p>
                            </div>
                        </div>
                        <div class="contact-item">
                            <i class="bi bi-envelope-fill text-info"></i>
                            <div>
                                <strong>邮箱</strong>
                                <p class="mb-0 text-light">service@huazai.com</p>
                            </div>
                        </div>
                    </div>
                    <div class="social-links mt-4">
                        <a href="#" class="social-link" title="微信">
                            <i class="bi bi-wechat"></i>
                        </a>
                        <a href="#" class="social-link" title="微博">
                            <i class="bi bi-sina-weibo"></i>
                        </a>
                        <a href="#" class="social-link" title="QQ">
                            <i class="bi bi-qq"></i>
                        </a>
                        <a href="#" class="social-link" title="抖音">
                            <i class="bi bi-tiktok"></i>
                        </a>
                    </div>
                </div>
            </div>

            <hr class="my-4 border-light">

            <div class="row align-items-center">
                <div class="col-md-6">
                    <p class="mb-0 text-center text-md-start">
                        <i class="bi bi-c-circle"></i> 2024 华仔购物总站
                    </p>
                </div>
                <div class="col-md-6 text-center text-md-end">
                    <p class="mb-0">
                        <small>技术支持：华仔科技团队 | 京ICP备12345678号</small>
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import bootstrap from 'bootstrap'
export default {
    name: 'ShopFooter',
    props: {
        categories: {
            type: Object,
            required: true
        }
    },
    computed: {
        totalSelectedItems() {
            let total = 0;
            Object.values(this.categories || {}).forEach(category => {
                if (Array.isArray(category)) {
                    category.forEach(item => {
                        if (item.checked && item.count > 0) total += item.count;
                    });
                }
            });
            return total;
        },
        totalAmount() {
            let total = 0;
            Object.values(this.categories || {}).forEach(category => {
                if (Array.isArray(category)) {
                    category.forEach(item => {
                        if (item.checked && item.count > 0) total += item.price * item.count;
                    });
                }
            });
            return total;
        },
        totalCategories() {
            return Object.keys(this.categories || {}).length;
        }
    },
    methods: {
        scrollToCategory(category) {
            const element = document.getElementById(category);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                
                // 激活对应的标签页
                const tab = document.getElementById(`${category}-tab`);
                if (tab) {
                    const tabTrigger = new bootstrap.Tab(tab);
                    tabTrigger.show();
                }
            }
        },
        getCategoryCount(categoryName) {
            return this.categories[categoryName]?.length || 0;
        },
        clearCart() {
            Object.values(this.categories || {}).forEach(category => {
                if (Array.isArray(category)) {
                    category.forEach(item => {
                        item.checked = false;
                        item.count = 0;
                    });
                }
            });
            this.$emit('clear-cart');
        }
    }
}
</script>

<style scoped>
.bg-gradient-dark {
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
}

.text-gradient-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.bg-glass {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-links {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.nav-link-custom {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    color: #ffffff;
    text-decoration: none;
    border-radius: 0.5rem;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.1);
}

.nav-link-custom:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateX(5px);
}

.icon-wrapper {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

.contact-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.contact-item {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.5rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 0.5rem;
}

.contact-item i {
    font-size: 1.25rem;
    margin-top: 0.125rem;
}

.social-links {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    color: #ffffff;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 1.25rem;
}

.social-link:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-3px);
}

@media (max-width: 768px) {
    .nav-link-custom {
        font-size: 0.875rem;
    }
    
    .contact-item {
        font-size: 0.875rem;
    }
    
    .social-links {
        justify-content: center;
    }
}
</style>